import React from 'react';
import MainLayout from '../layouts/MainLayout';
import { Container, Typography, Box } from '@mui/material';
import { useAuthContext } from '../contexts/AuthContext';
import { Permissao } from '../types/permissao.type';

const TestePage = () => {
  const {  user } = useAuthContext();

  // Defina aqui a permissão necessária para acessar esta página.
 const permissaoNecessaria:Permissao = {
    id:0,
    acao: 'can_read',
    entidade: 'cliente'
 }

  // Verifica se o usuário tem a permissão.
  // Estou assumindo que `usuario.permissoes` é um array de strings.
  console.log(user?.permissoes)
  const temPermissao = user?.permissoes?.some(p => p.acao === permissaoNecessaria.acao && p.entidade === permissaoNecessaria.entidade);

  return (
    <MainLayout>
      <Container maxWidth="xl">
        <Box sx={{ my: 4 }}>
          <Typography variant="h4" component="h1" gutterBottom>
            Página de Teste com Verificação de Permissão
          </Typography>
          {temPermissao ? (
            <Typography variant="body1">Este é o conteúdo da página de teste.</Typography>
          ) : (
            <Typography variant="body1" color="error">Sem permissão para visualizar este conteúdo.</Typography>
          )}
        </Box>
      </Container>
    </MainLayout>
  );
};

export default TestePage;